export const ContentLabelProp = Object.freeze({
    Position: 'position',
    Text: 'text',
    TextColor: 'textColor',
    PopupTitle: 'popupTitle',
    PopupText: 'popupText',
});
